import { Maybe } from 'tsmonad';
import { Core } from '../../Constants';
import { rdf } from '../../Vocabs';
export function Mixin(Base) {
    class ManagesBlock extends Base {
        get subject() {
            return this.get(Core.Vocab('subject'));
        }
        get property() {
            return this.get(Core.Vocab('property'));
        }
        get object() {
            const maybeClass = Maybe.maybe(this.get(Core.Vocab('object')));
            const classId = maybeClass.bind(c => Maybe.maybe(c.id));
            const getClass = this.apiDocumentation.map((doc) => doc.getClass.bind(doc));
            return classId
                .chain(id => getClass.bind(fun => Maybe.maybe(fun(id))))
                .caseOf({
                just: c => c,
                nothing: () => maybeClass.valueOr(null),
            });
        }
        matches({ subject = '', predicate = rdf.type, object = '' }) {
            const predicateId = typeof predicate === 'string' ? predicate : predicate.id;
            const objectId = typeof object === 'string' ? object : object.id;
            const subjectId = typeof subject === 'string' ? subject : subject.id;
            if (object && this.object && this.property) {
                const predicateIsRdfType = predicateId === rdf.type;
                return predicateIsRdfType && this.object.id === objectId && this.property.id === predicateId;
            }
            if (subject && predicate && this.subject && this.property) {
                return this.subject.id === subjectId && this.property.id === predicateId;
            }
            return false;
        }
    }
    return ManagesBlock;
}
export const shouldApply = (res) => {
    return res._reverseLinks.filter((link) => link.predicate === Core.Vocab('manages')).length > 0;
};
//# sourceMappingURL=ManagesBlock.js.map